module.exports = __webpack_public_path__ + "static/media/unisocks2.0043a647.png";